import { render, staticRenderFns } from "./WeightCard.vue?vue&type=template&id=fa104fec&scoped=true&"
import script from "./WeightCard.vue?vue&type=script&lang=js&"
export * from "./WeightCard.vue?vue&type=script&lang=js&"
import style0 from "./WeightCard.vue?vue&type=style&index=0&id=fa104fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa104fec",
  null
  
)

export default component.exports